export const CONTACTS_CONTENT = {
  title: 'КОНТАКТЫ',
  blocks: [
    {type: 'paragraph', text: 'Мы очень приветствуем и благодарны за любую обратную связь и вопросы по игре.'},
    {type: 'emailLink', label: 'Контактная почта для любых обращений:', email: 'strategikon.game@yandex.ru'},
    {type: 'heading', text: 'Данные организации'},
    {type: 'paragraph', text: 'ИП Баценков Ярослав Сергеевич'},
    {type: 'paragraph', text: 'ИНН 671406364925, ОГРНИП 326670000037519'},
    {type: 'paragraph', text: 'Смоленская область, Смоленский район, с. Пригорское, ул. Пляжная, д. 14'},
  ],
};
